export const DICTIONARY_PT = {
  schedule: {
    day: 'dia',
    week: 'semana',
    workWeek: 'Semana de trabalho',
    month: 'Mês',
    agenda: 'Agenda',
    weekAgenda: 'Agenda da semana',
    workWeekAgenda: 'Agenda da Semana de Trabalho',
    monthAgenda: 'Agenda do mês',
    today: 'Hoje',
    noEvents: 'Não há eventos',
    allDay: 'Todo o dia',
    start: 'Começo',
    end: 'Fim',
    more: 'Mais',
    close: 'Fechar',
    cancel: 'Cancelar',
    noTitle: '(Sem titulo)',
    delete: 'Apagar',
    deleteEvent: 'Eliminar evento',
    selectedItems: 'Artígos selecionados',
    deleteSeries: 'Eliminar série',
    edit: 'Editar',
    editSeries: 'Editar série',
    editEvent: 'Editar evento',
    createEvent: 'Criar',
    subject: 'Tema',
    addTitle: 'Acrescentar titulo',
    moreDetails: 'Mais detalhes',
    save: 'Salvar',
    editContent: 'Queres editar só este evento ou toda a série?',
    deleteRecurrenceContent: 'Deseja eliminar só este evento ou toda a série?',
    deleteContent: 'De certeza que queres eliminar este evento?',
    newEvent: 'Novo evento',
    title: 'Titulo',
    location: 'Localização',
    description: 'Descrição',
    timezone: 'Zona horária',
    startTimezone: 'Hora de início',
    endTimezone: 'Fim da zona horária',
    repeat: 'Repetir',
    saveButton: 'Salvar',
    cancelButton: 'Cancelar',
    deleteButton: 'Apagar',
    recurrence: 'Reaparição',
    editRecurrence: 'Editar recorrência',
    repeats: 'Repete',
    alert: 'Alerta',
    groups: 'operários',
    startEndError: 'A data de finalização selecionada ocorre antes da data de início.',
    invalidDateError: 'O valor da data recolhida não é válida.',
    ok: 'De acordo',
  },
  recurrenceeditor: {
    none: 'Nenhuma',
    daily: 'Diário',
    weekly: 'semanal',
    monthly: 'Mensal',
    month: 'Mês',
    yearly: 'Anual',
    never: 'Nunca',
    until: 'Até',
    count: 'Contar',
    first: 'First',
    second: 'Segundo',
    third: 'Terceiro',
    fourth: 'Quarto',
    last: 'Último',
    repeat: 'Repetir',
    repeatEvery: 'Repete cada',
    on: 'Repete em',
    end: 'Fim',
    onDay: 'Dia',
    days: 'Dias)',
    weeks: 'Semanas)',
    months: 'Meses)',
    years: 'Anos)',
    every: 'cada',
    summaryTimes: 'vezes)',
    summaryOn: 'em',
    summaryUntil: 'até',
    summaryRepeat: 'Repete',
    summaryDay: 'dias)',
    summaryWeek: 'semanas)',
    summaryMonth: 'meses)',
    summaryYear: 'anos)',
  },
  calendar: {
    today: 'hoje',
  },
  datepicker: {
    today: 'Hoje',
  },
  grid: {
    EmptyRecord: 'Não há resultados',
    True: 'verdadeiro',
    ShowRowsWhere: 'Mostrar linhas onde:',
    Add: 'Acrescentar',
    Edit: 'Editar',
    Cancel: 'Cancelar',
    Update: 'Atualizar',
    Delete: 'Apagar',
  },
  pager: {
    currentPageInfo: '{0} de {1} páginas',
    totalItemsInfo: '({0} registos)',
    firstPageTooltip: 'Ir à primeira página',
    lastPageTooltip: 'Ir à última página',
    nextPageTooltip: 'Ir à próxima página',
    previousPageTooltip: 'Ir à página anterior',
    nextPagerTooltip: 'Go to next pager',
    previousPagerTooltip: 'Go to previous pager',
    pagerDropDown: 'Items por página',
    pagerAllDropDown: 'Items',
    All: 'Tudo',
  },
  dropdowns: {
    noRecordsTemplate: 'Sem registos',
    actionFailureTemplate: 'Erro no modelo',
    overflowCountTemplate: '+${count} mais..',
    totalCountTemplate: '${count} selecionado',
  },
  daterangepicker: {
    startLabel: 'Data de início',
    endLabel: 'Data de início',
    applyText: 'Aplicar',
    cancelText: 'Cancelar',
    selectedDays: 'Dias selecionados',
    days: 'Dias',
  },
};
